import { userHasRole } from "../../../misc/utils"
import Psychology from "./Psychology"
import { PsychologyAdmin } from "./PsychologyAdmin"

export const PsychologyMain = () => {
    if (userHasRole('psychologist_admin')) {
        return (<PsychologyAdmin />)
    }
    return <Psychology />
}